<template>
    <div class="page">
        <div class="page-hedaer line-bar-bottom">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item to="/system/account">账号设置</el-breadcrumb-item>
                <el-breadcrumb-item>修改手机</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="page-body form-page">
            <el-form :model="form" :rules="rules" ref="form" label-width="150px">
                <el-form-item label="原手机号码：" prop="old_phone">
                    <el-input
                        v-model="form.old_phone"
                        placeholder="请输入手机号"
                        clearable
                        auto-complete="off"
                        maxlength="11"
                    ></el-input>
                </el-form-item>

                <el-form-item label="新手机号码：" prop="new_phone">
                    <el-input
                        v-model="form.new_phone"
                        placeholder="请输入手机号"
                        clearable
                        auto-complete="off"
                        maxlength="11"
                    ></el-input>
                </el-form-item>

                <el-form-item label="图片验证：" prop="imgCode" class="el-form-code">
                    <el-input
                        v-model="form.imgCode"
                        placeholder="请输入验证码"
                        clearable
                        auto-complete="off"
                        maxlength="4"
                    ></el-input>

                    <div class="code-img" @click="handleGetImg">
                        <div class="img">
                            <el-image :src="captchaImg" alt="验证码">
                                <div slot="placeholder">加载中...</div>
                            </el-image>
                        </div>
                        <span>看不清，换一张</span>
                    </div>
                </el-form-item>

                <el-form-item label="短信验证：" prop="sms_code" class="el-form-vcode">
                    <el-input
                        v-model="form.sms_code"
                        placeholder="请输入短信验证码"
                        clearable
                        auto-complete="off"
                        maxlength="6"
                    ></el-input>

                    <el-button
                        type="primary"
                        plain
                        :loading="isMsgSending"
                        :disabled="!form.new_phone || !form.imgCode || isMsgCounting"
                        @click="handleGetMsg"
                    >{{isMsgCounting ? msgSendSecond + '秒后可重发' : '发送验证码'}}</el-button>
                </el-form-item>

                <el-form-item class="el-form-btn">
                    <el-button
                        type="primary"
                        size="medium"
                        :disabled="!isFormSubmit"
                        :loading="sending"
                        @click="handleFormSubmit"
                    >保存</el-button>
                    <el-button size="medium" @click="$router.go(-1)">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { getCaptchaImage, getMsg } from '@/api/common';
import { updatePhone } from '@/api/account';

import { validatePhone, validateImgCode, validatePhoneCode } from '@/validate';

export default {
  name: 'accountBindPhonePage',
  data() {
    return {
      sending: false,
      isMsgSending: false,
      isMsgCounting: false,
      msgSendSecond: 60,
      msgSendTime: null,

      isFormSubmit: false,
      captchaImg: '',

      form: {
        old_phone: '',
        new_phone: '',
        imgCode: '',
        sms_code: '',
      },
      rules: {
        old_phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        new_phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        imgCode: [{ required: true, validator: validateImgCode, trigger: 'blur' }],
        sms_code: [{ required: true, validator: validatePhoneCode, trigger: 'blur' }],
      },
    };
  },
  watch: {
    form: {
      handler(value) {
        let tmpPass = true;

        Object.keys(value).forEach((key) => {
          if (value[key] === '') {
            tmpPass = false;
          }
        });

        this.isFormSubmit = tmpPass;
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.handleGetImg();
  },
  methods: {
    // 获取图片验证码
    handleGetImg() {
      getCaptchaImage().then((res) => {
        this.form.imgCode = '';
        this.captchaImg = res;
      }).catch(() => {});
    },
    // 获取短信验证码
    handleGetMsg() {
      let validateCount = 2;

      if (this.isMsgSending) {
        return false;
      }

      // 校验手机号码和图片验证码
      this.$refs.form.validateField(['new_phone', 'imgCode'], (errorMsg) => {
        validateCount = !errorMsg ? (validateCount - 1) : validateCount;
        // console.log(errorMsg);
        if (validateCount === 0) {
          this.isMsgSending = true;

          getMsg({
            phone: this.form.new_phone,
            imgCode: this.form.imgCode,
            type: 1,
          }).then((res) => {
            this.isMsgSending = false;

            if (res.data === 1) {
              this.$message({
                type: 'error',
                showClose: true,
                message: '新手机号码已被注册',
              });

              return false;
            }

            this.$message({
              type: 'success',
              showClose: true,
              message: '验证码发送成功',
            });

            // 倒计时
            this.msgSendSecond = 60;
            this.isMsgCounting = true;
            this.handleCountdown();
          }).catch(() => {
            this.isMsgSending = false;

            // this.handleGetImg();
          });
        }
      });
    },

    // 倒计时
    handleCountdown() {
      clearTimeout(this.msgSendTime);

      this.msgSendTime = setTimeout(() => {
        this.msgSendSecond -= 1;

        if (this.msgSendSecond > 0) {
          this.handleCountdown();
        } else {
          this.isMsgCounting = false;
        }
      }, 1000);
    },

    // 提交
    handleFormSubmit() {
      if (this.sending) {
        return false;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sending = true;

          updatePhone({
              user_id: this.$store.getters.userId,
              old_phone: this.form.old_phone,
              new_phone: this.form.new_phone,
              sms_code: this.form.sms_code,
              // imgCode: this.form.imgCode,
          }).then(() => {
            this.sending = false;

            this.$message({
              type: 'success',
              showClose: true,
              message: '手机号修改成功！',
            });

            this.$store.dispatch('SetUserInfo', {
              type: 'phone',
              value: this.form.new_phone,
            }).then(() => {
              this.$router.push({ path: '/system/account' });
            });
          }).catch(() => {
            this.sending = false;
            this.handleGetImg();
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '../../styles/variables.scss';
</style>
